import { Link as Route
  // useNavigate 
} from 'react-router-dom';
import { experimentalStyled, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import NewLogin from 'src/pages/NewLogin';


const useStyles = makeStyles((theme) => ({

       footerV: {
        position: 'absolute',
        top: theme.spacing(1),
        left: theme.spacing(2.5),
      },
      footerD: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(2.5)
      }
})
);

const MainLayoutRoot = experimentalStyled('div')(
  ({ theme }) => ({
    position: 'relative',
    backgroundColor: '#BCCAE0',
    // display: 'flex',
    height: '100%',
    overflow: 'hidden',
    // width: '100%',
    maxWidth: '450px',
    margin: 'auto'
  })
);


const MainLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const MainLayout = () => {
    const classes = useStyles();
  return(
  <MainLayoutRoot>
        <MainLayoutContent>
           <Route path="/login" component={NewLogin} />
        </MainLayoutContent>
        <a href="https://www.facebook.com/Sherwincarreon07" target="_blank">
        <Typography variant="caption" className={classes.footerV}
        >Transac v1.0</Typography>
                </a>
      <a href="https://www.facebook.com/jaybeepido" target="_blank">
        <Typography variant="caption" className={classes.footerD}
        >Powered By Ai-CPA</Typography>
        </a>
  </MainLayoutRoot>
);
  }
export default MainLayout;
